// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"197a2649","455":"406bb6ff","977":"18069f1b"}[chunkId] + ".chunk.js";
};